module.exports = __webpack_public_path__ + "img/GOMO_WIFI_MESH_6.png";